import { useCallback, useMemo } from "react";
import * as yup from "yup";

const FACTORY_FIELDS = [
    {
        id: "description",
        type: "text",
        name: "description",
        label: "Description (optional)",
        input: {
            placeholder: "Enter description on your token´s collection"
        },
    },
    {
        id: "type",
        type: "text",
        name: "type",
        label: "Type"
    }
]

const useMasterContractFormData = (contractType, contractId, upgradableContract) => {

    const generateVersion = useCallback(() => {
        let version = 1;
        if (!contractId) {
            version = "0.1";
        } else {
            version += +upgradableContract.version * 10;
            version = parseFloat(version / 10).toFixed(1);
        }
        return version;
    }, [contractId, upgradableContract]);

    const schema = useMemo(() => {
        switch(contractType) {
            case "factory":
                return yup.object().shape({
                    abi: yup.string().required("ABI is required"),
                    bytecode: yup.string().required("Bytecode is required"),
                    description: yup.string(),
                    type: yup.string().oneOf(["ERC20", "ERC721", "ERC721A", "ERC721PSI", "ERC1155"]).required()
                });
            default:
                return yup.object().shape();
        }
    }, [contractType]);

    const formFieldsData = useMemo(() => {
        switch(contractType) {
            case "factory":
                return FACTORY_FIELDS;
            default:
                return [];
        }
    }, [contractType]);

    const getInitialValues = useCallback(() => {

        switch(contractType) {
            case "factory":
                return {
                    version: generateVersion(),
                    abi: "",
                    bytecode: "",
                    type: "ERC20",
                    description: upgradableContract?.description || "",
                }
            default:
                return {};
        }
    }, [contractType, upgradableContract, generateVersion]);
    
    return { formFieldsData, getInitialValues, schema }
}

export { useMasterContractFormData };